export const TOTAL_STEPS = 3;
